import React, { useState } from 'react';

import DomainTechnologies from '../../components/domainTechnologies.js'
import WebsiteSecondaryPageTitle from '../../components/websiteSecondaryPageTitle.js'

import {TechnologiesPageResult} from '../../../../server/routes/website.js'

interface WebsiteTechnologiesData {
    server: string;
    pageData: unknown;
}

export default function WebsiteTechnologies({ server, pageData }: WebsiteTechnologiesData) {

	let [data, setData] = useState(pageData as TechnologiesPageResult);

    // TODO: all that code below is the same for /website/* pages ... create a component out of it
    return (<>
        <WebsiteSecondaryPageTitle domainPageHeader={data.DomainPageHeader}/>
        <section className="section section-sm">
            <div className="container">
                <DomainTechnologies 
                    technologies={data.Technologies}
                />    
            </div>
        </section>
    </>)
}
